import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-sm-9" }
const _hoisted_4 = { class: "col-sm-3" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 1,
  class: "mt-0 mb-4"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { colspan: "2" }
const _hoisted_9 = { class: "d-flex align-items-center py-3" }
const _hoisted_10 = {
  key: 0,
  class: "ms-1 fs_14"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)
const _hoisted_12 = {
  key: 1,
  class: "ms-1 fs_14"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("sub", { class: "custom-px-2 custom-fs-10" }, "2", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_field = _resolveComponent("form-field")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.availableYears.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_form_field, {
                  type: "select-string",
                  list: _ctx.availableYears,
                  modelValue: _ctx.selectedYear,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedYear) = $event)),
                  labelKey: "Time period",
                  labelValue: "Time period",
                  placeholderKey: "Select a time period",
                  placeholderValue: "Select a time period",
                  onChange: _ctx.updateTimePeriod
                }, null, 8, ["list", "modelValue", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Results visualization",
                  text: "Results visualization",
                  class: "d-block mb-2 pb-1 fw_700"
                }),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn w-50 justify-content-center me-2", !_ctx.tonnesVisualization ? 'btn-tertiary': 'btn-secondary withBorder']),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tonnesVisualization = false))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Kg",
                      text: "Kg"
                    })
                  ], 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["btn w-50 justify-content-center", _ctx.tonnesVisualization ? 'btn-tertiary': 'btn-secondary withBorder']),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tonnesVisualization = true))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Tonnes",
                      text: "Tonnes"
                    })
                  ], 2)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.availableYears.length > 1)
          ? (_openBlock(), _createElementBlock("hr", _hoisted_6))
          : _createCommentVNode("", true),
        _createVNode(_component_op_table, {
          class: "table table-striped",
          items: _ctx.ghgInventoryData.tableValues,
          itemsPerPage: 100
        }, {
          default: _withCtx((opData) => [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Scope",
                    text: "Scope"
                  })
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
                  return (_openBlock(), _createElementBlock("td", { key: year }, _toDisplayString(year), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (opData.data.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _createElementVNode("td", _hoisted_8, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "No Elements Found",
                        text: "No Elements Found"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.GHGInventoryDataVM[]), (item, i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _createElementVNode("td", null, _toDisplayString(item.name), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
                    return (_openBlock(), _createElementBlock("td", { key: year }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.$utils.getEmissionValue(_ctx.getValueForYear(item.valuesPerYear, year), _ctx.tonnesVisualization))), 1),
                        (!_ctx.tonnesVisualization)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                              _createTextVNode("(Kg CO"),
                              _hoisted_11,
                              _createTextVNode("e)")
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                              _createTextVNode("(Tonnes CO"),
                              _hoisted_13,
                              _createTextVNode("e)")
                            ]))
                      ])
                    ]))
                  }), 128))
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["items"])
      ]))
    : _createCommentVNode("", true)
}